import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/alerts'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  loading: false,
  statusLoading: false,
  historyLoading: false,
  historyError: false,
  removeActive: false,
  previewActive: false,
  previewLoading: false
})

export default handleActions({
  [Actions.fetchAlertsStart]: state => state.set('loading', true),
  [Actions.fetchAlertsSuccess]: state => state.set('loading', false),
  [Actions.fetchAlertsError]: state => state.set('loading', false),

  [Actions.fetchAlertHistoryStart]: state => state
    .set('historyLoading', true)
    .set('historyError', false),
  [Actions.fetchAlertHistorySuccess]: state => state
    .set('historyLoading', false)
    .set('historyError', false),
  [Actions.fetchAlertHistoryError]: state => state
    .set('historyLoading', false)
    .set('historyError', true),

  [Actions.previewAlertStart]: state => state
    .set('previewActive', true)
    .set('previewLoading', true),
  [Actions.previewAlertSuccess]: state => state.set('previewLoading', false),
  [Actions.previewAlertError]: state => state
    .set('previewActive', false)
    .set('previewLoading', false),
  [Actions.hideAlertPreviewDialog]: state => state
    .set('previewActive', false)
    .set('previewLoading', false),

  [Actions.updateAlertsStatusStart]: state => state.set('statusLoading', true),
  [Actions.updateAlertsStatusSuccess]: state => state.set('statusLoading', false),
  [Actions.updateAlertsStatusError]: state => state.set('statusLoading', false),

  [Actions.showRemoveAlertDialog]: state => state.set('removeActive', true),
  [Actions.hideRemoveAlertDialog]: state => state.set('removeActive', false),

  [AppActions.resetState]: () => initialState
}, initialState)
